import { TabItem } from '@/shared/components/ui/tab';
import { BetConfigSport, Sport, StatusItem } from '@/shared/types';

export const imagekit = import.meta.env.VITE_IMAGEKIT_URL;

export const DefineIcons = [
  {
    id: 1,
    title: 'Deposit',
    // icon: `${imagekit}/downline/deposit.svg`,
    icon2: 'D',
  },
  {
    id: 2,
    title: 'Withdraw',
    // icon: `${imagekit}/downline/withdraw.svg`,
    icon2: 'W',
  },
  {
    id: 3,
    title: 'Profile',
    icon: `${imagekit}/downline/profile.svg`,
  },
  {
    id: 4,
    title: 'Sport Permission',
    icon: `${imagekit}/downline/sportpermission.svg`,
  },
  {
    id: 5,
    title: 'Change Status',
    icon: `${imagekit}/downline/changestatus.svg`,
  },
];

export const badgeConfig: Record<string, { code: string; bg: string }> = {
  ['super admin']: { code: 'SA', bg: 'bg-primary' },
  ['master']: { code: 'MA', bg: 'bg-[#FEB759]' },
  ['user']: { code: 'PL', bg: 'bg-brown' },
};

export const initialSports: Sport[] = [
  { id: 1, name: 'cricket', label: 'Cricket', active: true },
  { id: 2, name: 'football', label: 'Football', active: true },
  { id: 3, name: 'tennis', label: 'Tennis', active: true },
  { id: 4, name: 'horse_racing', label: 'Horse Racing', active: true },
  { id: 5, name: 'basketball', label: 'Basketball', active: true },
  { id: 6, name: 'boxing', label: 'Boxing', active: true },
  { id: 7, name: 'baseball', label: 'Baseball', active: true },
  { id: 8, name: 'american_football', label: 'American Football', active: true },
  { id: 9, name: 'esports', label: 'Esports', active: true },
];

export const STATUS_OPTIONS: StatusItem[] = [
  {
    label: 'Active',
    nameValue: 'Active',
    value: 1,
    textColorClass: 'text-dark-green',
    backgroundColorClass: 'bg-dark-green',
  },
  {
    label: 'Invited',
    nameValue: 'Invited',
    value: 2,
    textColorClass: 'text-yellow-600',
    backgroundColorClass: 'bg-yellow-600',
  },
  {
    label: 'Blocked',
    nameValue: 'Blocked',
    value: 3,
    textColorClass: 'text-red-700',
    backgroundColorClass: 'bg-red-700',
  },
  {
    label: 'Locked',
    nameValue: 'Locked',
    value: 4,
    textColorClass: 'text-black',
    backgroundColorClass: 'bg-black',
  },
  {
    label: 'Freeze',
    nameValue: 'Freeze',
    value: 5,
    textColorClass: 'text-indigo-700',
    backgroundColorClass: 'bg-indigo-700',
  },
];

export enum UserRole {
  'Super Admin' = 'Super Admin',
  Master = 'Master',
  User = 'User',
}

export const eventManageTab: TabItem[] = [
  { id: 'import', label: 'InActive Matches' },
  { id: 'inplay', label: 'InPlay' },
  { id: 'upcoming', label: 'Upcoming' },
];

export const SportsFilterList = [
  'cricket',
  'football',
  'tennis',
  'horse_racing',
  'greyhound_racing',
  'basketball',
  'boxing',
  'baseball',
  'american_football',
  'esports',
];

export const statusColor = {
  Active: 'text-dark-green bg-light border border-green-600',
  Invited: 'bg-yellow-100 text-yellow-600 border border-yellow-600',
  Freeze: 'text-indigo-600 bg-indigo-100/50 border border-indigo-600',
  Locked: 'text-black bg-gray-100 border border-black',
  Blocked: 'text-red-700 bg-red-100 border border-red-700',
} as const;

export const dotColor = {
  Active: 'bg-dark-green',
  Invited: 'bg-yellow-600',
  Freeze: 'bg-indigo-600',
  Locked: 'bg-black',
  Blocked: 'bg-red-700',
} as const;

export const BetListTab: TabItem[] = [{ id: 'Hierarchy', label: 'Hierarchy Users' }];

export const userListTab: TabItem[] = [{ id: 'Platform', label: 'Owners Users' }];

export const contentManagementTabs = [
  {
    id: 2,
    label: 'Notification Management',
    img: `${imagekit}/contentManagement/notification.svg`,
  },
  {
    id: 3,
    label: 'Support Contact Management',
    img: `${imagekit}/contentManagement/support.svg`,
  },
];

export const managementTabs: TabItem[] = [
  {
    id: 'Banner',
    label: 'Banner Management',
    img: '/images/contentManagement/banner.svg',
  },
  {
    id: 'Notification',
    label: 'Notification Management',
    img: '/images/contentManagement/notification.svg',
  },
  {
    id: 'Contact',
    label: 'Support Contact Management',
    img: '/images/contentManagement/support.svg',
  },
];

export const Sports: TabItem[] = [
  { label: 'All', id: 'All' },
  { label: 'Cricket', id: 'cricket' },
  { label: 'Football', id: 'football' },
  { label: 'Tennis', id: 'tennis' },
  { label: 'Horse Racing', id: 'horse_racing' },
  { label: 'Greyhound Racing', id: 'greyhound_racing' },
  { label: 'Basketball', id: 'basketball' },
  { label: 'Boxing', id: 'boxing' },
  { label: 'Baseball', id: 'baseball' },
  { label: 'American Football', id: 'american_football' },
  { label: 'Esports', id: 'esports' },
];
export const SportsStatus: TabItem[] = [
  { label: 'All', id: 'All' },
  { label: 'Pending', id: 'pending' },
  { label: 'Won', id: 'won' },
  { label: 'Lost', id: 'lost' },
  { label: 'Cancelled', id: 'cancelled' },
  { label: 'Reverted', id: 'reverted' },
  // { label: 'Placed', id: 'placed' },
  // { label: 'Void', id: 'void' },
  // { label: 'Settled', id: 'settled' },
];

export const BET_CONFIG_SPORTS: { id: BetConfigSport; label: string }[] = [
  { id: 'cricket', label: 'Cricket' },
  { id: 'football', label: 'Football' },
  { id: 'tennis', label: 'Tennis' },
  { id: 'horse_racing', label: 'Horse Racing' },
  { id: 'greyhound_racing', label: 'Greyhound Racing' },
  { id: 'basketball', label: 'Basketball' },
  { id: 'boxing', label: 'Boxing' },
  { id: 'baseball', label: 'Baseball' },
  { id: 'american_football', label: 'American Football' },
  { id: 'esports', label: 'Esports' },
];

export const BusinessReportTabs: TabItem[] = [
  { label: 'First Deposit', id: 'FIRST' },
  { label: 'Refill Deposit', id: 'REFILL' },
];
export const STATUS_LOGOUT_MESSAGES: Record<string, string> = {
  inactive: 'Your account has been deactivated. You have been logged out.',
  suspended: 'Your account has been suspended. You have been logged out.',
  bet_lock: 'Betting has been locked on your account. You have been logged out.',
};

export const SubUserTabs: TabItem[] = [
  { label: 'Master', id: 'UpperHierarchy' },
  { label: 'Users', id: 'User' },
];

export const AccountStatementTabs: TabItem[] = [
  { label: 'Deposit/Withdraw', id: 'Deposit/Withdraw' },
  { label: 'Game Transaction', id: 'Game Transaction' },
];
